import { styled } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
const StyledDataGrid = styled(DataGrid)(({ theme: { palette } }) => ({
    '& .MuiButtonBase-root.MuiCheckbox-root': {
        color: palette.primary.main,
    },
    '& .MuiDataGrid-columnHeaders': {
        color: palette.common.white,
        backgroundColor: palette.primary.main,
        '.MuiIconButton-root': {
            color: palette.common.white,
        },
        '.MuiCheckbox-root.Mui-checked': {
            color: palette.secondary.main,
        },
        '.MuiCheckbox-root .MuiSvgIcon-root': {
            clipPath: 'inset(0.25rem 0.25rem)',
            backgroundColor: palette.common.white,
        },
        '.MuiCheckbox-root.Mui-checked .MuiSvgIcon-root': {
            clipPath: 'inset(0.2rem 0.2rem)',
        },
    },
    '& .MuiDataGrid-iconButtonContainer': {
        visibility: 'visible',
        width: 'auto',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 700,
    },
    '& .MuiDataGrid-cell:focus': {
        outline: 'none',
    },
    '& .MuiDataGrid-cell:focus-within': {
        outline: 'none',
    },
}));
export default StyledDataGrid;
